module.exports = __webpack_public_path__ + "static/media/thumbs_up.ef2ee3f7.svg";